import './display.css'

// The reusable main-display shell (mirrors MainNav on the sidebar side). Bars are
// optional slots rendered in a fixed order so every window looks consistent, no
// matter which bars a given window uses. The body is passed as children (wrap it
// in <Display> for the scroll/padding behaviour).
//
// Order: header -> searchbar -> iconbar -> locationbar -> body.
function DisplayWindow({ header, searchbar, iconbar, locationbar, children }) {
  return (
    <div className="display-window">
      {header}
      {searchbar}
      {iconbar}
      {locationbar}
      {children}
    </div>
  )
}

export default DisplayWindow
